var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterFilterTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.9,
    height: 42.1,
    viewBox: "0 0 41.9 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_17",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_372",
    x: 0,
    y: 0.1,
    width: 41.9,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER_FILTER",
    "data-name": "WATER FILTER",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_17)",
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2733",
    d: "m29.994 4.6-1.409 1.405A16 16 0 1 1 7.3 6.12L5.891 4.7a18 18 0 1 0 24.1-.106"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_372)",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 30.436a3.018 3.018 0 0 0 3-3.036c0-1.676-3-5.965-3-5.965s-3 4.289-3 5.965a3.018 3.018 0 0 0 3 3.035m1.335-4.023a.78.78 0 1 1-.771.78.775.775 0 0 1 .771-.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.485 0H7.515v3.487l7.813 7.893v8.573l5.32-3.492V11.3l7.831-7.83h.006zm-8.837 15.921-3.32 2.179v-6.376h3.32zm.259-5.3h-3.918L8.9 3.468h18.165zm7.581-8.157h-19V1h19z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFilterTool);
export default __webpack_public_path__ + "static/media/water-filter-tool.81ad51e2e20d47611f048904a6789546.svg";
export { ForwardRef as ReactComponent };